module.exports = __webpack_public_path__ + "storeHome/img/mobile-idLimited-1111.f3334f9e.png";